var chunkMapping = {
	"0": [
		4886
	],
	"148": [
		5075
	],
	"149": [
		5076
	],
	"152": [
		5079
	],
	"153": [
		5080
	],
	"154": [
		5081
	],
	"155": [
		5082
	],
	"156": [
		5083
	],
	"157": [
		5084
	],
	"158": [
		5085
	],
	"159": [
		5086
	],
	"160": [
		5087
	],
	"161": [
		5088
	],
	"162": [
		5089
	],
	"163": [
		5090
	],
	"164": [
		5091
	],
	"165": [
		5092
	],
	"166": [
		5093
	],
	"167": [
		5094
	],
	"168": [
		5095
	]
};
var idToExternalAndNameMapping = {
	"4886": [
		"default",
		"./Containers",
		3794
	],
	"5075": [
		"default",
		"./AsyncEventTracker",
		3794
	],
	"5076": [
		"default",
		"./HostWrapper",
		3794
	],
	"5079": [
		"default",
		"./CheckoutV3",
		3794
	],
	"5080": [
		"default",
		"./CheckoutConfirmation",
		3794
	],
	"5081": [
		"default",
		"./AuditDialog",
		3794
	],
	"5082": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3794
	],
	"5083": [
		"default",
		"./InvoiceDialog",
		3794
	],
	"5084": [
		"default",
		"./PaymentDueModal",
		3794
	],
	"5085": [
		"default",
		"./PaymentModal",
		3794
	],
	"5086": [
		"default",
		"./ContactCreditCards",
		3794
	],
	"5087": [
		"default",
		"./PaymentHistory",
		3794
	],
	"5088": [
		"default",
		"./PaymentConfigurations",
		3794
	],
	"5089": [
		"default",
		"./PaymentPreferences",
		3794
	],
	"5090": [
		"default",
		"./ManagePaymentProcessing",
		3794
	],
	"5091": [
		"default",
		"./MobilePaymentsWrapper",
		3794
	],
	"5092": [
		"default",
		"./Challenge",
		3794
	],
	"5093": [
		"default",
		"./ManagePaymentMethods",
		3794
	],
	"5094": [
		"default",
		"./LightspeedReports",
		3794
	],
	"5095": [
		"default",
		"./ShippingPromotionsListContainer",
		3794
	]
};
var idToRemoteMap = {
	"4886": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5075": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5076": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5079": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5080": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5081": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5082": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5083": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5084": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5085": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5086": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5087": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5088": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5089": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5090": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5091": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5092": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5093": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5094": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	],
	"5095": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3794
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}